import Accordion from 'react-bootstrap/Accordion';

export default function InstructionMessage() {
    return(
        <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
            <Accordion.Header>DVI Viewer for LuaTeX</Accordion.Header>
            <Accordion.Body>    
            <p>
                This is a demo React app for the <code>dvi-decode</code> Javascript module.
                (<a href="https://github.com/matjp/dvi-decode" rel="nofollow">https://github.com/matjp/dvi-decode</a>)
            </p>
            <p>
                <code>dvi-decode</code> works only with <code>dvi</code> files generated by <code>LuaTeX</code>, and with
                the package <code>luaotfload</code> version {'>'}= 3.15
            </p>
            <p>
                Use the <code>dvilualatex</code> command to generate the <code>dvi</code> file.
            </p>
            <p>
                Use the <code>unicode-math</code> package if math mode is used.
            </p>
            </Accordion.Body>    
            </Accordion.Item>
        </Accordion>
    );
  }
  